module.exports = __webpack_public_path__ + "img/a_groupWork.84a869ab.png";